import { createSlice } from "@reduxjs/toolkit";

export const communityDetails = createSlice({
  name: "communityDetails",
  initialState: JSON.parse(localStorage.getItem("communityData")) || null,
  reducers: {
    setCommunityData: (state, action) => {
      return (state = action.payload);
    },
  },
});

export const { setCommunityData } = communityDetails.actions;

export default communityDetails.reducer;
